import { PrimaryButton } from 'components/widgets/buttons/buttons';

// Modules
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { FormCard, TableCard } from 'components/content-containers/cards';
import { PageContent } from 'components/page';
import { Table } from 'components/content-containers/tables/tables';
import EmptyPagePlaceholder from 'components/page/empty-page-placeholder';
import FlipMove from 'components/widgets/animation/flip-move';
import TimeReportForm from 'components/models/time-report/forms/time-report-form';
import TimeReportRowSimple from 'components/models/time-report/time-report-row-simple';

import * as util from '../utils/load-ticket';


// Component
class TicketTime extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object,
    updateTask: PropTypes.func,
    updateTime: PropTypes.func,
    timeReports: PropTypes.array,
    ticket: PropTypes.object,
    teams: PropTypes.array
  };

  constructor(props) {
    super(props);

    this.editForms = {};
    this.state = { showAllTimeReports: false };
    this.eagerUpdate = this.eagerUpdate.bind(this);
    this.afterSubmit = this.afterSubmit.bind(this);
  }

  eagerUpdate(values) {
    const { timeReports, ticket } = this.props;
    const report = _.find(timeReports, { id: values.id });
    const rate = values.rate ? _.find(ticket.agreement.rates, { id: values.rate }) || report.rate : null;

    this.props.updateTime(_.defaults({ rate }, values, report));
  }

  afterSubmit() {
    util.loadTimeReports(this.props.ticket);
  }

  render() {
    const { ticket, timeReports, currentUser } = this.props;
    const hasAgreement = _.get(ticket, 'agreement.id');
    const { showAllTimeReports } = this.state;
    
    if (!ticket || _.isEmpty(ticket)) return null;
    if (!hasAgreement) return <EmptyPagePlaceholder src="svg/time-report.svg">Add an agreement to add time to this ticket!</EmptyPagePlaceholder>;

    const isArchived = ticket.status === 'Archived';
    const time = _.orderBy(timeReports, [report => moment(report.date).toDate()], ['desc']);
    const defaultRate = _.find(ticket.agreement.rates, { role: currentUser.billingRole });
    const totalTime = _.reduce(timeReports, (total, report) => total + Number(report.duration), 0);
    const maxTimeReports = 20;
    const limitTimeReports = time.length > maxTimeReports && !showAllTimeReports;
    const visibleTime = limitTimeReports ? _.take(time, maxTimeReports) : time;

    return (
      <PageContent className="bg-medium-blue-grey ticket">
        <div className="ticket-time">
          { !isArchived &&
            <FormCard>
              <TimeReportForm
                resetOnSubmit
                cancel={this.cancel}
                afterSubmit={this.afterSubmit}
                form="ticket-add-time-report"
                preventAutoFocus
                initialValues={{
                  date: moment(),
                  rate: ticket.timeDefaultBillable ? defaultRate.id : 0,
                  createdBy: currentUser.id,
                  agreement: ticket.agreement.id,
                  ticket: ticket.id,
                  afterHoursPremium: _.get(ticket, 'agreement.afterHoursPremium', 0)
                }}
                agreement={ticket.agreement}
                ticket={ticket}
              />
            </FormCard>
          }
          <TableCard className="time-table">
            <Table>
              <thead>
                <tr>
                  <th className="collapse-width">Date</th>
                  <th className="collapse-width">User</th>
                  <th>Description</th>
                  <th className="right-align collapse-width">Time</th>
                  <th className="collapse-width"></th>
                </tr>
              </thead>
              <FlipMove typeName="tbody" enterAnimation="fade" leaveAnimation="fade">
                {_.map(visibleTime, (report) => <TimeReportRowSimple key={report.id} report={report} eagerUpdate={this.eagerUpdate} />)}
                { limitTimeReports &&
                  <tr>
                    <td className="vertical-align-middle text-center" colSpan="5">
                      <span className="mr-3">{time.length - maxTimeReports} more time reports hidden</span>
                      <PrimaryButton onClick={() => this.setState({ showAllTimeReports: true })}>Show All</PrimaryButton>
                    </td>
                  </tr>
                }
                <tr className="total-row">
                  <td colSpan="3">Total Time</td>
                  <td className="right-align">{totalTime.toFixed(2)}</td>
                  <td></td>
                </tr>
              </FlipMove>
            </Table>
          </TableCard>
        </div>
      </PageContent>
    );
  }
}

// Exports
export default connect((state) => ({
  ticket: state.tickets.ticket,
  timeReports: state.tickets.timeReports,
  currentUser: state.auth.currentUser,
  teams: state.pageData.teams
}))(TicketTime);



// WEBPACK FOOTER //
// ./app/routes/ticket/sub-routes/ticket-time.js